var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',[_c('SiteMasthead',{attrs:{"title":"Property Report","mini":"true"}}),_c('div',{attrs:{"id":"daintegration","data-cid":"753"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }